import React, { useEffect, useState } from 'react'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { useQuery } from '@apollo/client'
import { GET_ALL_PAYPAL_TRANSATION } from '../../graphql/query'
import { useStateWithCallback } from '../../utils/hooks/useStateWithCallback'
import LoadingSpinner from '../../components/LoadingSpinner'

pdfMake.vfs = pdfFonts as unknown as typeof pdfMake.vfs

const PaypalDetails = () => {
  const [currentPage, setCurrentPage] = useState(1)
  const [PaypalDate, setPaypalDate] = useStateWithCallback<any>({
    // startDate: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0],
    // endDate: new Date().toISOString().split('T')[0],
    startDate: '',
    endDate: '',
    paypalMode: 'sandbox'
  })

  useEffect(() => {
    paypalRefetch({
      input: {
        ...PaypalDate
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PaypalDate])

  const {
    loading,
    error,
    data: PaypalData,
    refetch: paypalRefetch
  } = useQuery(GET_ALL_PAYPAL_TRANSATION, {
    variables: {
      input: {
        ...PaypalDate // Using the state values
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Configuration'
      }
    }
  })

  const accountPerPage = 10
  const transactions = PaypalData?.getAllPayPalTransation?.data || []
  const totalCount = transactions?.length
  const totalPages = Math.ceil(totalCount / accountPerPage)

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.target.name
    const value = e.target.value

    setPaypalDate((prevValue: any) => ({
      ...prevValue,
      [name]: value
    }))
  }

  const generatePdf = (transaction: any) => {
    const { transaction_info } = transaction
    if (!transaction_info) return

    const docDefinition: any = {
      content: [
        { text: 'PayPal Transaction Invoice', style: 'header' },
        { text: `Transaction ID: ${transaction_info.transaction_id}`, style: 'subheader' },
        { text: `Event Code: ${transaction_info.transaction_event_code}` },
        {
          text: `Transaction Date: ${new Date(
            transaction_info.transaction_initiation_date
          ).toLocaleString()}`
        },
        {
          text: `Updated Date: ${new Date(
            transaction_info.transaction_updated_date
          ).toLocaleString()}`
        },
        { text: `Amount: USD $${transaction_info.transaction_amount?.value}` },
        { text: `Status: ${transaction_info.transaction_status === 'S' ? 'SUCCESS' : 'FAILED'}` },
        { text: `Transaction Subject: ${transaction_info.transaction_subject}` },
        { text: `Ending Balance: USD $${transaction_info.ending_balance?.value}` },
        { text: `Available Balance: USD $${transaction_info.available_balance?.value}` },
        { text: '' },
        { text: 'Terms and Conditions', style: 'subheader' },
        { text: '1. All payments are final and non-refundable unless specified otherwise.' },
        { text: '2. Any disputes shall be resolved under the jurisdiction of Delhi, India.' },
        { text: '3. For support, contact info@botgotechpvtltd.com.' }
      ],
      styles: {
        header: { fontSize: 18, bold: true, margin: [0, 0, 0, 10] },
        subheader: { fontSize: 14, bold: true, margin: [0, 10, 0, 5] }
      }
    }

    pdfMake.createPdf(docDefinition).download(`Transaction_${transaction_info.transaction_id}.pdf`)
  }

  const truncateText = (text: string, length: number) => {
    return text.length > length ? text.substring(0, length) + '...' : text
  }

  if (error) return <h1>{error.message}</h1>

  const renderTableRows = (data: any) => {
    return data?.map((row: any, index: number) => (
      <tr key={index}>
        {/* Transaction ID */}
        <td>
          <span
            className='badge badge-light-danger fs-7 fw-bold btn-active-light-primary'
            title={`Transaction ID: ${row.transaction_info.transaction_id}`}
          >
            {row.transaction_info.transaction_id || 'N/A'}
          </span>
        </td>

        {/* Event Code */}
        <td>{row.transaction_info.transaction_event_code || 'N/A'}</td>

        {/* Initiation Date */}
        <td>
          {new Date(row.transaction_info.transaction_initiation_date).toLocaleString() || 'N/A'}
        </td>

        {/* Updated Date */}
        <td>{new Date(row.transaction_info.transaction_updated_date).toLocaleString() || 'N/A'}</td>

        {/* Amount */}
        <td>USD ${parseFloat(row.transaction_info.transaction_amount.value).toFixed(2)}</td>

        {/* Status */}
        <td>
          <div
            className={`badge ${
              row.transaction_info.transaction_status === 'S'
                ? 'badge-light-success'
                : row.transaction_info.transaction_status === 'P'
                ? 'badge-light-warning'
                : 'badge-light-danger'
            }`}
          >
            {row.transaction_info.transaction_status === 'S'
              ? 'SUCCESS'
              : row.transaction_info.transaction_status === 'P'
              ? 'PENDING'
              : 'FAILED'}
          </div>
        </td>

        {/* Transaction Subject */}
        <td title={row.transaction_info.transaction_subject}>
          {truncateText(row.transaction_info.transaction_subject || '', 25)}
        </td>

        {/* Ending Balance */}
        <td>USD ${parseFloat(row.transaction_info.ending_balance.value).toFixed(2)}</td>

        {/* Available Balance */}
        <td>USD ${parseFloat(row.transaction_info.available_balance.value).toFixed(2)}</td>

        {/* Download Invoice */}
        <td>
          <button
            className='btn btn-sm btn-primary my-1 d-flex align-items-center gap-1'
            onClick={() => generatePdf(row)}
          >
            <i className='bi bi-download fs-5'></i> Download
          </button>
        </td>
      </tr>
    ))
  }

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber)
  }

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1)
    }
  }

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1)
    }
  }

  const generatePaginationNumbers = () => {
    let numbers = []
    for (let i = 1; i <= totalPages; i++) {
      numbers.push(i)
    }
    return numbers
  }
  const displayedTransactions = transactions.slice(
    (currentPage - 1) * accountPerPage,
    currentPage * accountPerPage
  )

  return (
    <>
      {!!loading ? (
        <div className='h-100 d-flex align-items-center justify-content-center '>
          <LoadingSpinner />
        </div>
      ) : (
        <div className='card mb-5 mb-xl-10'>
          <div className=''>
            <div className='card-header'>
              <div>
                <h3>Paypal Payment History ({totalCount || 0})</h3>
                <div className='fs-6 fw-semibold text-gray-500'>
                  See history of your paypal payment
                </div>
              </div>
              {/* <div className='col-4 d-flex justify-content-end mb-3'>
                <div className='d-flex'>
                  <div className='d-flex align-items-center'>
                    <label className='form-label me-2' htmlFor='startDate'>
                      From:
                    </label>
                    <input
                      type='date'
                      name='startDate'
                      id='startDate'
                      value={PaypalDate.startDate}
                      min={
                        new Date(Date.now() - 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
                      }
                      max={PaypalDate.endDate || ''}
                      className='form-control mx-3'
                      onChange={handleDateChange}
                    />
                  </div>
                </div>
                <div className='d-flex align-items-center'>
                  <label className='form-label me-2' htmlFor='endDate'>
                    To:
                  </label>
                  <input
                    type='date'
                    name='endDate'
                    id='endDate'
                    value={PaypalDate.endDate}
                    min={PaypalDate.startDate || ''}
                    max={new Date().toISOString().split('T')[0]}
                    className='form-control mx-3'
                    onChange={handleDateChange}
                  />
                </div>
              </div> */}
            </div>

            <div className='tab-content'>
              <div id='kt_billing_months' className='card-body p-0 tab-pane fade show active'>
                <div className='table-responsive'>
                  <table className='table table-row-bordered align-middle gy-4 gs-9'>
                    <thead className='border-bottom border-gray-200 fs-6 fw-bold bg-light bg-opacity-75'>
                      <tr>
                        <td className='min-w-100px'>Transaction ID</td>
                        <td className='min-w-100px'>Event Code</td>
                        <td className='min-w-150px'>Transaction Date</td>
                        <td className='min-w-150px'>Updated Date</td>
                        <td className='min-w-100px'>Amount (USD)</td>
                        <td className='min-w-100px'>Status</td>
                        <td className='min-w-150px'>Transaction Subject</td>
                        <td className='min-w-100px'>Ending Balance</td>
                        <td className='min-w-100px'>Available Balance</td>
                        <td className='min-w-100px'>Download Invoice</td>
                      </tr>
                    </thead>

                    <tbody className='fw-semibold text-gray-600'>
                      {displayedTransactions.length > 0 ? (
                        renderTableRows(displayedTransactions)
                      ) : (
                        <tr>
                          <td className='text-center p-5 fw-bold text-gray-500'>
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className='row m-2'>
                  <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start dt-toolbar'></div>
                  <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
                    <div className='dt-paging paging_simple_numbers'>
                      <div
                        className='dataTables_paginate paging_simple_numbers'
                        id='kt_table_users_paginate'
                      >
                        <ul className='pagination pb-2'>
                          <li
                            className={`paginate_button page-item ${
                              currentPage === 1 ? 'disabled' : ''
                            }`}
                          >
                            <button
                              type='button'
                              aria-controls='kt_table_users'
                              data-dt-idx='0'
                              className='btn primary page-link'
                              onClick={prevPage}
                            >
                              <i className='previous'></i>
                            </button>
                          </li>
                          {generatePaginationNumbers().map((pageNumber) => (
                            <li
                              key={pageNumber}
                              className={`paginate_button page-item ${
                                currentPage === pageNumber ? 'active' : ''
                              }`}
                            >
                              <button
                                type='button'
                                aria-controls='kt_table_users'
                                data-dt-idx={pageNumber}
                                className='btn primary page-link'
                                onClick={() => paginate(pageNumber)}
                              >
                                {pageNumber}
                              </button>
                            </li>
                          ))}
                          <li
                            className={`paginate_button page-item ${
                              currentPage === totalPages ? 'disabled' : ''
                            }`}
                          >
                            <button
                              type='button'
                              aria-controls='kt_table_users'
                              data-dt-idx='0'
                              className='btn primary page-link'
                              onClick={nextPage}
                            >
                              <i className='next'></i>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default PaypalDetails
